import styled from 'styled-components';

export const Container = styled.div`
  padding: 2rem;
`;

export const FieldSection = styled.div`
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1.5rem;
  background-color: #fafafa;
`;

export const FieldGroup = styled.div`
  margin-bottom: 1.5rem;
`;

export const Label = styled.label`
  display: block;
  font-weight: bold;
  margin-bottom: 0.5rem;
`;

export const Input = styled.input`
  width: 80%;
  padding: 0.5rem;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

export const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 2rem;
`;

export const Button = styled.button`
  padding: 0.5rem 1.25rem;
  font-size: 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  background-color: ${props => (props.primary ? '#007bff' : '#ccc')};
  color: white;
`;

export const SectionTitle = styled.h2`
  margin: 10px;
`;

export const TextSmall = styled.small`
  margin: 10px;
`;

export const Toggle = styled.label`
  position: relative;
  display: inline-block;
  width: 46px;
  height: 24px;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  span {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    border-radius: 24px;
    transition: 0.3s;
  }

  span:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    border-radius: 50%;
    transition: 0.3s;
  }

  input:checked + span {
    background-color: #007bff;
  }

  input:checked + span:before {
    transform: translateX(22px);
  }
`;

export const Description = styled.p`
  margin: 4px 0 12px 0;
  font-size: 0.85rem;
  color: #666;
`;

export const Note = styled.p`
  margin-top: 0.5rem;
  font-size: 0.85rem;
  color: #666;
  font-style: italic;
`;